"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)("circle", {
    cx: "250.5",
    cy: "145.8",
    r: "83.3"
  }), (0, _core.jsx)("path", {
    d: "M251.6 270.8c-84 0-153.5 62.2-165 143-1.8 12.5 8.1 23.7 20.7 23.7h288.6c12.6 0 22.5-11.2 20.7-23.7-11.5-80.8-80.9-143-165-143z"
  }));
};

exports.default = _default;